<template>
	<div class="appView rapidEamilPage">
		<Sidebar></Sidebar>
		<main class="mainContent">
			<div class="navBar">
				<Hamburger />
				<div class="title">Rapid Email</div>
				<div class="headerSeparator"></div>
			</div>
			<Loading :active.sync="isLoading" :is-full-page="fullPage" />
			<div v-if="!isLoading" class="rapidEmailContainer">
				<div class="wrapper">
					<div class="heroEmailIcon">
						<img src="../../public/img/send@2x.png" alt="" />
					</div>
					<h4 class="title">
						Upload receipts and<br />
						invoices via your email
					</h4>
					<ul class="instructions">
						<li>
							Forward receipts by emailing them to your RapidReceipt email
							address below.
						</li>
						<li>
							RapidReceipt will automatically add your receipts to your account.
						</li>
					</ul>
					<div class="actionContainer container">
						<small class="label">Your RapidReceipt Email :</small>
						<span class="rapidEmailAddress">{{ userRapidEmail }}</span>

						<button
							class="copyButton"
							v-clipboard:copy="userRapidEmail"
							v-clipboard:success="onCopy"
							v-clipboard:error="onError"
						>
							<img
								class="copyIcon"
								src="../../public/svg/copy-icon-white.svg"
							/>
							Copy Email
						</button>
						<span
							v-if="emailCopyResponseMessage"
							:class="{
								emailCopyStatusMessage: true,
								success: isEmailCopySuccess,
								fail: !isEmailCopySuccess
							}"
						>
							<img
								v-if="isEmailCopySuccess"
								src="../../public/svg/success-mark-icon.svg"
							/>
							<img v-else src="../../public/svg/error-cross-icon.svg" />
							{{ emailCopyResponseMessage }}</span
						>
					</div>
				</div>
			</div>
		</main>
	</div>
</template>

<script>
import Loading from "vue-loading-overlay";
import { getUserId } from "../utils/auth";
import Sidebar from "../components/Sidebar.vue";
import Hamburger from "../components/Hamburger.vue";

export default {
	data() {
		return {
			userRapidEmail: "",
			isLoading: true,
			fullPage: false,
			isEmailCopySuccess: false,
			emailCopyResponseMessage: ""
		};
	},
	components: {
		Sidebar,
		Loading,
		Hamburger
	},
	async mounted() {
		try {
			this.isLoading = true;
			const userId = getUserId();
			const response = await this.$axios.get(`/user/info?user_id=${userId}`);
			this.userRapidEmail = response.data.rapid_email;
		} catch (error) {
			return error;
		} finally {
			this.isLoading = false;
		}
	},
	methods: {
		onCopy: function(e) {
			this.isEmailCopySuccess = true;
			this.emailCopyResponseMessage = "Email copied to clipboard";
			setTimeout(() => {
				this.emailCopyResponseMessage = "";
			}, 2000);
		},
		onError: function(e) {
			this.isEmailCopySuccess = false;
			this.emailCopyResponseMessage = "Failed to copy. Please try again";
		}
	}
};
</script>
